export default __webpack_public_path__ + "static/media/Closed.2e5a08d5.svg";